import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19v-7l-5 -7","key":"svg-0"}],["path",{"d":"M17 5l-5 7","key":"svg-1"}],["path",{"d":"M8 13h8","key":"svg-2"}]]

const IconCurrencyYuan = createReactComponent('outline', 'currency-yuan', 'CurrencyYuan', __iconNode);

export default IconCurrencyYuan;